import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../data/site";

export const About = () => {
  const { t } = useLang();

  return (
    <section
      id="story"
      className="relative overflow-hidden bg-sand py-24 sm:py-32"
      data-testid="about-section"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-16 lg:grid-cols-12 lg:gap-12">
          {/* Left: heading + image */}
          <div className="lg:col-span-5">
            <span className="text-xs font-medium uppercase tracking-[0.3em] text-teal">
              {t.story.kicker}
            </span>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="mt-5 font-display text-4xl font-bold leading-tight tracking-tight text-purpleink-deep sm:text-5xl"
            >
              {t.story.title}
            </motion.h2>

            <div className="relative mt-10 flex h-80 items-center justify-center overflow-hidden rounded-[2rem] rounded-tr-none bg-white shadow-2xl sm:h-96">
              <img
                src={IMAGES.storefront}
                alt="Casa Romano · San Juan del Sur"
                className="h-full w-full object-contain p-6 sm:p-8"
              />
              <div className="absolute right-4 top-4 rounded-full bg-white/90 px-4 py-2 text-xs font-semibold uppercase tracking-wider text-purpleink shadow-lg backdrop-blur">
                Zona Central · SJDS
              </div>
            </div>
          </div>

          {/* Right: numbered chapters */}
          <div className="lg:col-span-6 lg:col-start-7">
            <div className="flex flex-col">
              {t.story.chapters.map((c, i) => (
                <motion.div
                  key={c.n}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                  className="grid grid-cols-[auto_1fr] gap-6 border-t border-purpleink/15 py-8 first:border-t-0 first:pt-0"
                >
                  <span className="font-display text-5xl font-bold text-marigold sm:text-6xl">
                    {c.n}
                  </span>
                  <div>
                    <h3 className="font-display text-2xl font-semibold text-purpleink-deep">
                      {c.t}
                    </h3>
                    <p className="mt-3 text-base leading-relaxed text-stone-600">
                      {c.b}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
